import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { LbMultipleAutocomplete } from '../../../../../shared/components/form-components';
import { FoodTag } from '../../../../interfaces/FoodTag';
import { FoodFormValues } from '../../interfaces/FoodFormValues';
import { FOOD_TAG_NAME } from '../../../../constants/foodTagName';
import { FoodTagChip } from '../../../../components/FoodTagChip/FoodTagChip';

type TagsFieldProps = {
  tags: FoodTag[];
};

const MACRO_TAG_NAMES: string[] = [
  FOOD_TAG_NAME.PROTEIN,
  FOOD_TAG_NAME.CARBOHYDRATE,
  FOOD_TAG_NAME.FAT,
  FOOD_TAG_NAME.OTHER,
  FOOD_TAG_NAME.CONDIMENTS,
];

const isMacroTag = ({ name }: FoodTag) => MACRO_TAG_NAMES.includes(name);

const TagsField = ({ tags }: TagsFieldProps) => {
  const { control } = useFormContext<FoodFormValues>();
  const selectedTags = useWatch({ control, name: 'tags' });

  const isSelected = (tag: FoodTag) => selectedTags.some(({ id }) => id === tag.id);

  return (
    <LbMultipleAutocomplete
      control={control}
      name="tags"
      label="Tags"
      options={tags}
      valueKey="id"
      labelKey="name"
      // need to make chip change color based on the tag name
      renderValue={(value, getItemProps) => {
        return value.map((option, index) => {
          const { key, ...itemProps } = getItemProps({ index });
          return (
            <FoodTagChip size="medium" label={option.name} key={key} {...itemProps} />
          );
        });
      }}
      // disabled macro tags if there are one already selected
      getOptionDisabled={(tag) =>
        selectedTags.some(isMacroTag) && isMacroTag(tag) && !isSelected(tag)
      }
      rules={{
        validate: (value, { recommended }) =>
          !recommended ||
          value.length > 0 ||
          "Cannot set recommended for food that doesn't have any tags.",
      }}
    />
  );
};

export { TagsField };
